import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import {
  ApplicationScheme,
  applicationSchemeToSlug,
  normalizeApplicationScheme,
} from '../constants/application-scheme';

@Injectable({
  providedIn: 'root',
})
export class WizardRedirectService {
  constructor(private readonly router: Router) {}

  redirectToCorrectWizard(
    application: unknown,
    applicationId: number | string,
    currentScheme: ApplicationScheme,
    queryParams?: Params
  ): boolean {
    const resolvedId = Number(applicationId);
    if (!resolvedId) {
      return false;
    }

    const schemeValue = this.extractApplicationScheme(application);
    if (!schemeValue) {
      return false;
    }

    const normalized = normalizeApplicationScheme(schemeValue);
    const targetScheme = normalized === ApplicationScheme.OTHER
      ? ApplicationScheme.CNCS
      : normalized;

    if (targetScheme === currentScheme) {
      return false;
    }

    const slug = applicationSchemeToSlug(targetScheme);
    const targetPath = `/${slug}/application/${resolvedId}`;
    this.router.navigate([targetPath], {
      queryParams: queryParams ?? undefined,
      replaceUrl: true,
    });

    return true;
  }

  private extractApplicationScheme(application: unknown): string | null {
    if (!application || typeof application !== 'object') {
      return null;
    }

    const payload = application as {
      application_type?: unknown;
      applicationType?: unknown;
      application_scheme?: unknown;
      applicationScheme?: unknown;
    };

    const value = payload.application_type
      ?? payload.applicationType
      ?? payload.application_scheme
      ?? payload.applicationScheme;

    return typeof value === 'string' ? value : null;
  }
}
